<aside class="panel-right ${calendar.selectedDay ? 'is-open' : ''}">
  <div class="releases-header">
    <span class="releases-header__title">Releases</span>
    <span class="releases-header__date">${calendar.selectedDateLabel}</span>
    <div class="releases-header__actions">
      <div class="view-toggle" role="group" aria-label="Releases view">
        <button
          type="button"
          class="view-toggle__btn ${calendar.releasesView === 'list' ? 'active' : ''}"
          click.trigger="calendar.setReleasesView('list')"
          title="List view"
          aria-label="List view"
          aria-pressed.bind="calendar.releasesView === 'list'"><span class="icon icon--view-list" aria-hidden="true"></span></button>
        <button
          type="button"
          class="view-toggle__btn ${calendar.releasesView === 'grid' ? 'active' : ''}"
          click.trigger="calendar.setReleasesView('grid')"
          title="Grid view"
          aria-label="Grid view"
          aria-pressed.bind="calendar.releasesView === 'grid'"><span class="icon icon--view-grid" aria-hidden="true"></span></button>
      </div>
      <button
        type="button"
        class="releases-expand__btn ${calendar.releasesExpanded ? 'active' : ''}"
        click.trigger="calendar.toggleReleasesExpanded()"
        title="${calendar.releasesExpanded ? 'Collapse releases' : 'Expand releases'}"
        aria-label="${calendar.releasesExpanded ? 'Collapse releases' : 'Expand releases'}"
        aria-pressed.bind="calendar.releasesExpanded"><span class="icon ${calendar.releasesExpanded ? 'icon--collapse' : 'icon--expand'}" aria-hidden="true"></span></button>
      <div if.bind="calendar.lastUpdated" class="updated-info" ref="updatedInfoEl">
        <button
          type="button"
          class="updated-info__btn ${calendar.updatedInfoOpen ? 'active' : ''}"
          click.trigger="calendar.toggleUpdatedInfo()"
          title="Last data update"
          aria-label="Last data update"
          aria-expanded.bind="calendar.updatedInfoOpen"><span class="icon icon--info" aria-hidden="true"></span></button>
        <span if.bind="calendar.updatedInfoOpen" class="updated-info__popover">Last updated: ${calendar.lastUpdated}</span>
      </div>
      <button
        type="button"
        class="panel-close panel-close--releases"
        click.trigger="calendar.closeReleasesPanel()"
        aria-label="Close releases"><span class="icon icon--close" aria-hidden="true"></span></button>
    </div>
  </div>
  <div class="releases-content">
    <div if.bind="!calendar.selectedDay" class="releases-empty">Select a day with releases to see details.</div>
    <div if.bind="calendar.selectedDay" class="releases-detail">
      <div class="calendar-loading-overlay" if.bind="calendar.dayLoading" aria-live="polite">
        <span class="calendar-loading-spinner" aria-hidden="true"></span>
        <span class="calendar-loading-text">Loading releases…</span>
      </div>
      <div class="releases-list releases-list--${calendar.releasesView} ${calendar.dayLoading ? 'is-loading' : ''}" ref="calendar.releasesListEl">
        <div repeat.for="group of calendar.releaseGroups" class="release-group">
          <h3 class="release-group__header">${group.header}</h3>
          <release repeat.for="release of group.releases"
            release.bind="release"
            view.bind="calendar.releasesView"
            can-subscribe.bind="subscriptions.isAvailabilityEligible(release)"
            is-subscribed.bind="subscriptions.isReleaseSubscribed(release) & signal:'subscriptions-changed'"
            subscription-pending.bind="subscriptions.isSubscriptionPending(release.key) & signal:'subscriptions-changed'"></release>
        </div>
      </div>
      <div if.bind="calendar.isPaginated" class="releases-pager">
        <button
          type="button"
          class="releases-pager__btn"
          click.trigger="calendar.firstReleasesPage()"
          disabled.bind="calendar.releasesPage <= 1 || calendar.dayLoading"
          aria-label="First page"><span class="icon icon--page-first" aria-hidden="true"></span></button>
        <button
          type="button"
          class="releases-pager__btn"
          click.trigger="calendar.prevReleasesPage()"
          disabled.bind="calendar.releasesPage <= 1 || calendar.dayLoading"
          aria-label="Previous page"><span class="icon icon--page-prev" aria-hidden="true"></span></button>
        <span class="releases-pager__label">${calendar.pageRangeLabel}</span>
        <button
          type="button"
          class="releases-pager__btn"
          click.trigger="calendar.nextReleasesPage()"
          disabled.bind="calendar.releasesPage >= calendar.totalPages || calendar.dayLoading"
          aria-label="Next page"><span class="icon icon--page-next" aria-hidden="true"></span></button>
        <button
          type="button"
          class="releases-pager__btn"
          click.trigger="calendar.lastReleasesPage()"
          disabled.bind="calendar.releasesPage >= calendar.totalPages || calendar.dayLoading"
          aria-label="Last page"><span class="icon icon--page-last" aria-hidden="true"></span></button>
      </div>
    </div>
  </div>
</aside>
